import { useEffect, useMemo, useState } from "react";
import { IoMdArrowBack } from "react-icons/io";
import { IoMdArrowForward } from "react-icons/io";
import { FaStar } from "react-icons/fa";
import { FaStarHalfAlt } from "react-icons/fa";
import { FaRegStar } from "react-icons/fa";
import ButtonHref from "../button";

import "./testimonials-index.css";

const defaultTestimonials = [
  {
    id: "1",
    name: "Ingryd Pachedo",
    course: "Correções para concursos",
    quote: "Uma das melhores professoras que eu já tive, eu super recomendo!",
    result: "Evoluí na estrutura e na argumentação",
    initials: "IP",
    color: "rose",
    star: 5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "2",
    name: "Samuel Louis",
    course: "Correções para concursos",
    quote:
      "A profª Iasmyn é uma educadora dedicada, sensível e extremamente comprometida com o aprendizado de seus alunos. Sua forma clara de explicar, aliada à paciência e ao respeito pelo ritmo de cada estudante, cria um ambiente seguro onde errar faz parte do processo de aprender.",
    result: "Feedback claro e personalizado",
    initials: "SL",
    color: "sage",
    star: 5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "3",
    name: "Alan Santana",
    course: "Mentoria individual",
    quote:
      "A professora Yasmin me ajudou muito a elevar minhas notas nas redações do Enem, depois do acompanhamento eu saltei de 640 para 920 na última redação.",
    result: "Mais confiança para escrever",
    initials: "AS",
    color: "lavender",
    star: 5,
    social: [{ label: "LinkedIn", url: "https://linkedin.com/" }],
  },
  {
    id: "4",
    name: "Eduardo ",
    course: "Redação ENEM",
    quote:
      "A Iasmyn é uma professora muito instruída e profissional. Possui boa didática, é atenciosa e muito paciente. Suas aulas são ótimas!",
    result: "Critérios de avaliação mais claros",
    initials: "ED",
    color: "sand",
    star: 4.5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "5",
    name: "Raygisla ",
    course: "Redação ENEM",
    quote:
      "Sou amiga da Iasmyn, e ela é uma excelente professora, muito responsável, dedicada, inteligente e tem o dom do ensino.",
    result: "Critérios de avaliação mais claros",
    initials: "RG",
    color: "sand",
    star: 4.5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "6",
    name: "Lucas ",
    course: "Redação ENEM",
    quote:
      "Iasmyn é uma professora incrível, ama o que faz e se dedica muito em ensinar. Meu nível de redação aumentou significativamente e sou grato por isso.",
    result: "Critérios de avaliação mais claros",
    initials: "LG",
    color: "sand",
    star: 4.5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "7",
    name: "Joao ",
    course: "Redação ENEM",
    quote:
      "Iasymyn é maravilhosa. Uma professora muito atenciosa e preocupada com a melhoria contínua. Super recomendo. Confio muito nos ensinamentos dela e agradeço por ter aprendido bastante com ela.",
    result: "Critérios de avaliação mais claros",
    initials: "JG",
    color: "sand",
    star: 4.5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "8",
    name: "Carlos ",
    course: "Redação ENEM",
    quote:
      "Excelente professora, correções bem detalhadas e bom atendimento sempre. Agradeço demais toda ajuda durante todo esse ano. Indico sempre!!!",
    result: "Critérios de avaliação mais claros",
    initials: "CP",
    color: "sand",
    star: 5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "9",
    name: "Italo ",
    course: "Redação ENEM",
    quote: "É uma excelente profissional, proativa e sempre disposta a ajudar.",
    result: "Critérios de avaliação mais claros",
    initials: "IS",
    color: "sand",
    star: 5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "10",
    name: "Paulo ",
    course: "Redação ENEM",
    quote: "Iasmyn explica super bem e de forma bem completa.",
    result: "Critérios de avaliação mais claros",
    initials: "IS",
    color: "sand",
    star: 5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "11",
    name: "Pedro ",
    course: "Redação ENEM",
    quote:
      "Professora muito dedicada em seu trabalho. Apresenta grande domínio em sua área. Excelente educadora.",
    result: "Critérios de avaliação mais claros",
    initials: "PV",
    color: "sand",
    star: 5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
  {
    id: "12",
    name: "Yasmim ",
    course: "Redação ENEM",
    quote:
      "Muito atenciosa e cuidadosa ao explicar as correções. Sempre que eu tive dúvidas me ajudou!Que Deus te abençoe hoje e sempre.",
    result: "Critérios de avaliação mais claros",
    initials: "IS",
    color: "sand",
    star: 5,
    social: [{ label: "Instagram", url: "https://instagram.com/" }],
  },
];

function TestimonialCard({ item }) {
  const initials =
    item.initials ||
    item.name
      ?.split(" ")
      .map((part) => part[0])
      .slice(0, 2)
      .join("");

  return (
    <article
      className="ep-testimonial-card"
      aria-label={`Depoimento de ${item.name}`}
    >
      <div
        className={`ep-testimonial-card-avatar ep-testimonial-card-avatar--${item.color || "sage"}`}
        aria-hidden="true"
      >
        {item.avatar ? (
          <img src={item.avatar} alt="" loading="lazy" />
        ) : (
          <span>{initials}</span>
        )}
      </div>
      <div className="ep-testimonial-card-rule" />
      <h3>{item.name}</h3>
      <p className="ep-testimonial-card-course">{item.course}</p>
      <div
        className="ep-testimonial-card-stars"
        aria-label="Avaliação de cinco estrelas"
      >
        {(() => {
          const fullStars = Math.floor(item.star || 0);
          const halfStar = item.star % 1 >= 0.5;
          const emptyStars = 5 - fullStars - (halfStar ? 1 : 0);

          return (
            <>
              {Array.from({ length: fullStars }).map((_, i) => (
                <FaStar key={`full-${i}`} />
              ))}
              {halfStar && <FaStarHalfAlt />}
              {Array.from({ length: emptyStars }).map((_, i) => (
                <FaRegStar key={`empty-${i}`} />
              ))}
            </>
          );
        })()}
      </div>
      <p className="ep-testimonial-card-quote">
        {/* “{item.quote.substring(0, 100)}…” */}
        “{item.quote}”
      </p>

      <div className="ep-testimonial-card-more">
        {/* <span className="ep-testimonial-card-detail">“{item.quote}”</span> */}
        <strong>{item.result || "Uma jornada de evolução"}</strong>
        {item.detail && <p>{item.detail}</p>}
        {item.social?.length > 0 && (
          <div
            className="ep-testimonial-card-socials"
            aria-label={`Redes sociais de ${item.name}`}
          >
            {item.social.map((link) => (
              <a
                key={`${link.label}-${link.url}`}
                href={link.url}
                target="_blank"
                rel="noreferrer"
              >
                {link.label}
              </a>
            ))}
          </div>
        )}
        {item.profileUrl && (
          <a
            className="ep-testimonial-card-profile"
            href={item.profileUrl}
            target="_blank"
            rel="noreferrer"
          >
            Ver perfil ↗
          </a>
        )}
      </div>
    </article>
  );
}

export default function TestimonialsCarousel({
  testimonials = defaultTestimonials,
  title = "Histórias de quem está evoluindo",
  subtitle = "Veja o que nossos alunos têm a dizer sobre suas experiências com nossas aulas, mentorias e correções de redação.",
  speed = 55,
}) {
  const [paused, setPaused] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [focused, setFocused] = useState(false);
  const [reducedMotion, setReducedMotion] = useState(false);

  const items = useMemo(
    () => (testimonials?.length ? testimonials : defaultTestimonials),
    [testimonials],
  );

  useEffect(() => {
    const media = window.matchMedia("(prefers-reduced-motion: reduce)");
    const update = () => setReducedMotion(media.matches);
    update();
    media.addEventListener?.("change", update);
    return () => media.removeEventListener?.("change", update);
  }, []);

  const shouldPause = paused || hovered || focused || reducedMotion;

  const moveByCard = (direction) => {
    // Manual controls pause the marquee; users can resume with the button.
    setPaused(true);
    const track = document.querySelector(".ep-testimonials-track");
    if (!track) return;
    const card = track.querySelector(".ep-testimonial-card");
    const gap = 20;
    const distance = (card?.getBoundingClientRect().width || 270) + gap;
    const current = Number(track.dataset.offset || 0);
    const next = current + direction * distance;
    track.dataset.offset = String(next);
    track.style.setProperty("--ep-manual-offset", `${next}px`);
    track.classList.add("is-manually-positioned");
  };

  const resume = () => {
    const track = document.querySelector(".ep-testimonials-track");
    if (track) {
      track.classList.remove("is-manually-positioned");
      track.dataset.offset = "0";
      track.style.removeProperty("--ep-manual-offset");
    }
    setPaused(false);
  };

  return (
    <section
      className="ep-testimonials"
      aria-labelledby="ep-testimonials-title"
    >
      <div className="ep-testimonials-heading">
        {/* <span className="ep-testimonials-eyebrow">Depoimentos</span> */}
        <h2 id="ep-testimonials-title">{title}</h2>
        <p>{subtitle}</p>
      </div>

      <div className="ep-testimonials-controls">
        <button
          className="ep-testimonials-arrow"
          type="button"
          aria-label="Mover para os depoimentos anteriores e pausar"
          onClick={() => moveByCard(-1)}
        >
          <IoMdArrowBack />
        </button>
        <button
          className="ep-testimonials-play"
          type="button"
          onClick={
            shouldPause && !hovered && !focused
              ? resume
              : () => setPaused((value) => !value)
          }
          aria-pressed={paused}
        >
          {paused ? "Retomar " : "Pausar "}
        </button>
        <button
          className="ep-testimonials-arrow"
          type="button"
          aria-label="Mover para os próximos depoimentos e pausar"
          onClick={() => moveByCard(1)}
        >
          <IoMdArrowForward />
        </button>
      </div>

      <div
        className={`ep-testimonials-viewport${shouldPause ? " is-paused" : ""}`}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
        onFocusCapture={() => setFocused(true)}
        onBlurCapture={(event) => {
          if (!event.currentTarget.contains(event.relatedTarget))
            setFocused(false);
        }}
        aria-label="Carrossel infinito de depoimentos"
      >
        <div
          className="ep-testimonials-track"
          style={{
            "--ep-duration": `${Math.max(12, items.reduce((sum, item) => sum + (item.cardWidth || 270) + 20, 0) / Math.max(speed, 10))}s`,
          }}
        >
          <div className="ep-testimonials-group">
            {items.map((item, index) => (
              <TestimonialCard
                key={`${item.id || item.name}-${index}`}
                item={item}
              />
            ))}
          </div>
          <div className="ep-testimonials-group" aria-hidden="true">
            {items.map((item, index) => (
              <TestimonialCard
                key={`duplicate-${item.id || item.name}-${index}`}
                item={item}
              />
            ))}
          </div>
        </div>
      </div>
      <a href="#depoimentos" className="all-testimonials">
        VER MAIS DEPOIMENTOS
      </a>
    </section>
  );
}
